import { Spinner } from 'react-bootstrap';

const LoadingElement = () => {
    return (
        <div className="spinner-canvas">
            <Spinner className="text-success" animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        </div>
    )
}

export default LoadingElement;